
export interface StorySegment {
  text: string;           
  imagePrompt: string;    
  imageUrl?: string;      
  audioData?: string;     // Base64 audio data generated at creation
}

export interface Story {
  id: string;
  userId: string;         
  title: string;
  segments: StorySegment[];
  createdAt: number;
}

export interface User {
  id: string;
  username: string;
  email: string;
  password?: string;
  avatarColor: string;
  joinedAt: number;
}

export enum InputLanguage {
  ARABIC = 'Arabic',
  FRENCH = 'French',
  ENGLISH = 'English',
  AMAZIGH = 'Amazigh'
}

export type UILanguage = 'ar' | 'fr' | 'en' | 'ber' | 'es';
